module.exports = __webpack_public_path__ + "static/media/icon_space_a.1bbfb7d5.svg";